import { render, staticRenderFns } from "./DialogInviteCollaborator.vue?vue&type=template&id=6a87bdd0"
import script from "./DialogInviteCollaborator.vue?vue&type=script&lang=js"
export * from "./DialogInviteCollaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports